import { Help } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Поддержка (БО-60, ПОРТ-61, ПОРТ-03): очередь обращений с контекстом экрана, переписка и статусы, запросы
 * доступа к данным клиник, статьи помощи RU/KK. DODOC_QA — обращения и доступ для разбора качества AI (без статей).
 */
export const section = defineSection({
  id: 'backoffice.support',
  area: 'backoffice',
  path: 'support/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT', 'DODOC_QA'],
  icon: Help,
  titleKey: 'boSupport:title',
  namespaces: ['portal', 'backoffice'],
  navGroup: 'support',
  order: 10,
  load: () => import('./SupportPage'),
});
